module.exports = __webpack_public_path__ + "img/preset2.10358779.png";